import { render, staticRenderFns } from "./unsubmit.vue?vue&type=template&id=ced19820&"
import script from "./unsubmit.vue?vue&type=script&lang=ts&"
export * from "./unsubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports